module.exports = __webpack_public_path__ + "static/img/btn4-checked.e3cee301.png";